import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import { Link } from "react-router-dom";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CustomEditor from '../Components/CustomEditor';
import Header from "../Components/Header";
import { ReactSession } from 'react-client-session';
import { useNavigate } from "react-router-dom";
ReactSession.setStoreType("localStorage");


const EditProduct = () => {
  const navigate = useNavigate();
 const userId=ReactSession.get("welbeingId");
  const [formData, setFormData] = useState({ 
  code: '',
  product: '',
  cat: '',
  sub_id: '',
  size: '',
  price: '',
  moq: '',
  weight: '',
  gst: '',
  stock: '',
  preOrder: 'no',
  des: '',
  colors: [{ id: '', code: '#000000', color: '' }],
  size_variation: [{ id: '', size: '', amount: '' }],
  design: [{ id: '', design: '' }],
  images: [null, null, null, null],
  img1: '',
  img2: '',
  img3: '',
  img4: ''
});

if(userId  <= 0 ){
      navigate('/login');
   }

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  console.log("form",formData)
  const [productId,setProductId] = useState(null);
  const [originalProduct, setOriginalProduct] = useState(null);
  const [editorLoaded, setEditorLoaded] = useState(false);
  const [editorData, setEditorData] = useState('');
   const [des, setDes] = useState("");

  console.log("selected category",selectedCategory);

  const location = useLocation();

  // Helper to get query params as an object
  const getQueryParams = () => {
    return new URLSearchParams(location.search);
  };



  useEffect(() => {
    const query = getQueryParams();
    const id = query.get('id');
    setProductId(id);
    console.log('Product ID from query:', id);

    // You can use this id to fetch the product data here
  }, [location]);
  // Fetch categories and subcategories once
  useEffect(() => { 
    axios.get('https://api.welbeing.in/admin/categories/categories/')
      .then(res => setCategories(res.data.data))
      .catch(console.error);

    axios.get('https://api.welbeing.in/admin/categories/subcategories/')
      .then(res => setSubCategories(res.data.data))
      .catch(console.error);
  }, []);

  useEffect(() => {
  setEditorLoaded(true);
  return () => setEditorLoaded(false);
}, []);

  // Fetch product data by productId and autofill
 const fetchProduct = async (id) => {
  try {
    const res = await axios.post(
      `https://api.welbeing.in/admin/products/single-product/`,
      { p_id: id }
    );
    const p = res.data.data;
    setOriginalProduct(p);
    console.log("response", res);
    console.log("product", p);

    setFormData({
      code: p.item_code || '',
      product: p.item_name || '',
      cat: p.cat || '',
      sub_id: p.sub_ids || '',
      size: p.item_size || '',
      price: p.item_price || '',
      moq: p.item_moq || '',
      weight: p.item_weight || '',
      gst: p.gst || '',
      stock: p.stock || '',
      preOrder: p.preOrder || 'no',
      des: p.des || '',
      colors: p.colors?.length
        ? p.colors.map(c => ({ id: c.id, code: c.code, color: c.color }))
        : [{ id: '', code: '#000000', color: '' }],
      size_variation: p.size?.length
        ? p.size.map(s => ({ id: s.id, size: s.size, amount: s.amount }))
        : [{ id: '', size: '', amount: '' }],
      design: p.designs?.length
        ? p.designs.map(d => ({ id: d.id, design: d.design }))
        : [{ id: '', design: '' }],
      images: [null, null, null, null],
      img1: p.img1 || 'no_img.jpg',
      img2: p.img2 || 'no_img.jpg',
      img3: p.img3 || 'no_img.jpg',
      img4: p.img4 || 'no_img.jpg'
    });

    setSelectedCategory(p.cat || '');
    setEditorData(p.des || '');
  } catch (err) {
    console.error('Failed to fetch product', err);
    // alert('Failed to load product data');
  }
};
useEffect(() => {
  if (productId) {
    fetchProduct(productId);
  }
}, [productId]);


  const filteredSubCategories = subCategories.filter(
    (sub) => String(sub.cat_id) === String(selectedCategory)
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (index, file) => {
    const updated = [...formData.images];
    updated[index] = file;
    setFormData(prev => ({ ...prev, images: updated }));
  };

  const handleColorChange = (index, field, value) => {
    const updated = [...formData.colors];
    updated[index][field] = value;
    setFormData(prev => ({ ...prev, colors: updated }));
  };

  const handleSizeChange = (index, field, value) => {
    const updated = [...formData.size_variation];
    updated[index][field] = value;
    setFormData(prev => ({ ...prev, size_variation: updated }));
  };  

  const addSizeInput = () => {
    setFormData(prev => ({
      ...prev,
      size_variation: [...prev.size_variation, { size: '', amount: '' }]
    }));
  };

  const addColorInput = () => {
    setFormData(prev => ({ 
      ...prev, 
      colors: [...prev.colors, { code: '#000000', color: '' }]
    }));
  };

 const handleDesignChange = (index, value) => {
  const updated = [...formData.design];
  updated[index] = { ...updated[index], design: value }; // preserve id
  setFormData(prev => ({ ...prev, design: updated }));
};


  const addDesignInput = () => {
  setFormData(prev => ({
    ...prev,
    design: [...prev.design, { id: '', design: '' }]
  }));
};



const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const productData = new FormData();
    const keys = ['code', 'product', 'cat', 'sub_id', 'size', 'price', 'moq', 'weight', 'gst', 'stock', 'preOrder', 'des','img1','img2','img3','img4'];
    keys.forEach((key) => productData.append(key, formData[key]));
    productData.append("p_id", productId); 

    formData.images.forEach((img, i) => {
      if (img) productData.append(`image${i + 1}`, img);
    });

    
    await axios.post(
      `https://api.welbeing.in/admin/products/edit-product/`,
      productData
    );


   for (const color of formData.colors) {
  if (color.id) {
    await axios.post('https://api.welbeing.in/admin/products/edit-color/', {
      id: color.id,
      p_id: productId,
      code: color.code,
      color: color.color
    });
  } else if (color.color) {
    await axios.post('https://api.welbeing.in/admin/products/add-color/', {
      p_id: productId,
      code: color.code,
      color: color.color
    });
  }
}


 
for (const designs of formData.design) {
  if (designs.id) {
    await axios.post('https://api.welbeing.in/admin/products/edit-design/', {
      id: designs.id,
      p_id: productId,
      design: designs.design
    });
  } else if (designs.design) {
    await axios.post('https://api.welbeing.in/admin/products/add-design/', {
      p_id: productId,
      design: designs.design
    });
  }
}


for (const sizes of formData.size_variation) {
  if (sizes.id) {
    await axios.post('https://api.welbeing.in/admin/products/edit-size/', {
      id: sizes.id,
      p_id: productId,
      size: sizes.size,
      amount: sizes.amount
    });
  } else {
      if(sizes.size!=''||sizes.amount!=''){
         await axios.post('https://api.welbeing.in/admin/products/add-size/', {
      p_id: productId,
      size: sizes.size,
      amount: sizes.amount
    });
      }
   
  }
}


    alert('Product updated successfully!');
    fetchProduct(productId)
  } catch (err) {
    console.error(err);
    alert('Failed to update product.');
  }
};

 const handleDeleteColour = async(id) => {  try {
    const response = await axios.post('https://api.welbeing.in/admin/products/delete-color/', {
      id: id,     
    });
    console.log(response.data);
    fetchProduct(productId); 

  } catch (error) {
    console.error("Error Deleting:", error);
  }
  };
   const handleDeleteSize = async(id) => {  try {
    const response = await axios.post('https://api.welbeing.in/admin/products/delete-size/', {
      id: id,     
    });
    console.log(response.data);
    fetchProduct(productId); 

  } catch (error) {
    console.error("Error Deleting:", error);
  }
  };

   const handleDeletedesign = async(id) => {  try {
    const response = await axios.post('https://api.welbeing.in/admin/products/delete-design/', {
      id: id,     
    });
    console.log(response.data);
    fetchProduct(productId); 

  } catch (error) {
    console.error("Error Deleting:", error);
  }
  };
  const handleDes = (event, editor) => {
        const data = editor.getData();
        setDes(data);
      };


      const handleDeleteimage = async (index) => {
  const columnName = `img${index + 1}`;
  const confirmDelete = window.confirm("Are you sure you want to remove this image?");
  if (!confirmDelete) return;

  try {
    const response = await axios.post('https://api.welbeing.in/admin/products/remove-image/', {
  image: columnName,
  p_id: productId,
});

 console.log("response",response.data)
    const result = response.data;
    if (result.status === "success") {
      alert("Image removed successfully");

      // Update the frontend view
      const updatedFormData = { ...formData };
      updatedFormData[columnName] = 'no_img.jpg';
      setFormData(updatedFormData);
    } else {
      alert(result.error.message || "Failed to remove image");
    }
  } catch (error) {
    console.error("Error removing image:", error);
    alert("Error while removing image");
  }
};


console.log("des",des)
  return (
     <>
    <Header/>
            <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
            
            
               <div class="body-wrapper">
    <div className="container-fluid">
        <div className="card bg-light-info shadow-none position-relative overflow-hidden">
          <div className="card-body px-4 py-3">
            <div className="row align-items-center">
              <div className="col-9">
                <h4 className="fw-semibold mb-2">All Products</h4>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard" className="text-muted">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">Products</li>
                  </ol>
                </nav>
              </div>
             
              <div className="col-3 text-center mb-n5">
                <img src="dist/images/breadcrumb/ChatBc.png" alt="Breadcrumb" className="img-fluid mb-n4" />

              </div>
            </div>
          </div>
        </div>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="card mt-3">
          <div className="card-body">
            <h5>Edit Product</h5>
            <div className="row">
              <div className="col-md-4 mb-3">
                <label>Item Code</label>
                <input
                  name="code"
                  className="form-control"
                  onChange={handleChange}
                  value={formData.code}
                  required
                />
              </div>
              <div className="col-md-8 mb-3">
                <label>Item Name</label>
                <input
                  name="product"
                  className="form-control"
                  onChange={handleChange}
                  value={formData.product}
                  required
                />
              </div>
              <div className="col-md-4 mb-3">
                <label>Category</label>
                <select
                  className="form-control"
                  value={selectedCategory}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSelectedCategory(val);
                    setFormData(prev => ({ ...prev, cat: val, sub_id: '' }));
                  }}
                >
                  <option value="">Select Category</option>
                  {categories.map(cat => (
                    <option key={cat.m_cate} value={cat.m_cate}>{cat.cate}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-4 mb-3">
                <label>Sub Category</label>
                <select
                  className="form-control"
                  disabled={!selectedCategory}
                  value={formData.sub_id}
                  onChange={(e) => setFormData(prev => ({ ...prev, sub_id: e.target.value }))}
                >
                  <option value="">Select Sub Category</option>
                  {filteredSubCategories.map(sub => (
                    <option key={sub.sub_id} value={sub.sub_id}>{sub.sub_cate}</option>
                  ))}
                </select>
              </div>
            <div className="col-md-4 mb-3">
                <label>Item Size</label>
                <input name="size" value={formData.size} className="form-control" onChange={handleChange} />
              </div>
              <div className="col-md-2 mb-3"><label>Price</label><input type="number" name="price" value={formData.price} className="form-control" onChange={handleChange} required /></div>
              <div className="col-md-2 mb-3"><label>MOQ</label><input name="moq" className="form-control" value={formData.moq} onChange={handleChange} required /></div>
              <div className="col-md-2 mb-3"><label>Weight</label><input name="weight" className="form-control" value={formData.weight} onChange={handleChange} /></div>
              <div className="col-md-2 mb-3"><label>GST %</label><input type="number" name="gst" className="form-control" value={formData.gst} onChange={handleChange} required /></div>
              <div className="col-md-2 mb-3"><label>Stock</label><input type="number" name="stock" className="form-control" value={formData.stock} onChange={handleChange} required /></div>
              <div className="col-md-2 mb-3">
                <label>Pre Order</label>
                <select name="preOrder" value={formData.preOrder} className="form-control" onChange={handleChange}>
                  
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
             {/* <div className="mb-3 col-md-12">
                <label htmlFor="des" className="form-label">DESCRIPTION</label>
               <CKEditor
                  editor={ClassicEditor}
                  data={des}
                  onChange={handleDes}
                />
                                                                  
             </div> */}
 <div className="mb-3 col-md-12">
  <label htmlFor="des" className="form-label">DESCRIPTION</label>
  <CustomEditor
  editor={ClassicEditor}
    value={formData.des}
    onChange={(data) => setFormData(prev => ({ ...prev, des: data }))}
  />

  
</div>
                {/* <div className="col-md-12 mb-3">
                <label>Description</label>     
  
                  <textarea 
                    className="form-control" 
                    value={formData.des} 
                    onChange={(e) => setFormData(prev => ({...prev, des: e.target.value}))}
                    rows="5"
                  />
  
              </div> */}


              {[0, 1, 2, 3].map(i => {
                const uploadedImage = formData.images[i];
                const existingImage = formData[`img${i + 1}`];
                console.log(existingImage)

                const imageUrl = uploadedImage
                  ? URL.createObjectURL(uploadedImage)
                  : existingImage 
                    ? `https://api.welbeing.in/uploads/products/${existingImage}`
                    : null;

                return (
                  <div className="col-md-3 mb-3" key={i}>

                    {imageUrl && (
                      <img
                        src={imageUrl}
                        alt={`preview${i}`}
                        className="img-thumbnail mt-2"
                        style={{ width: "50%", height: "auto", objectFit: "cover" }}
                      />
                    )}
                    <label
                      htmlFor={`image${i}`}
                      className="btn btn-success w-50 d-flex justify-content-center align-items-center w-100"
                      style={{ height: '40px' }}
                    >
                      <i style={{ color: '#fff', fontSize: '1rem', transition: 'all 0.3s ease', cursor: 'pointer'}} className="ti ti-upload" />
                       
                    </label>

                    {/* Hidden file input */}
                    <input
                      type="file"
                      id={`image${i}`}
                      accept="image/*"
                      style={{ display: 'none' }}
                      onChange={(e) => handleImageChange(i, e.target.files[0])}
                    />
                    <button
                      type="button"
                      onClick={() => handleDeleteimage(i)}
                      className="btn btn-danger w-100 mt-2"
                    >
                     <i style={{ color: '#fff', fontSize: '1rem', transition: 'all 0.3s ease', cursor: 'pointer'}} className="ti ti-trash" />
                                                       
                    </button>
                  </div>
                );
                })}


              <div className="col-md-4 mb-4">
                <label>Add Colors</label>
                {formData.colors.map((c, i) => (
                  <div className="form-group d-flex mt-2" key={i}>
                    <input
                      type="color"
                      className="form-control me-2"
                      style={{ width: 70, height: 40, padding: 0, border: '1px solid #ccc', appearance: 'none' }}
                      value={c.code}
                      onChange={(e) => handleColorChange(i, 'code', e.target.value)}
                    />
                    <input
                      type="text"
                      className="form-control me-2"
                      value={c.color}
                      onChange={(e) => handleColorChange(i, 'color', e.target.value)}
                    />
                    <button type="button" onClick={() => handleDeleteColour(c.id)} className="btn btn-danger "> <i style={{ color: '#fff', fontSize: '1rem', transition: 'all 0.3s ease', cursor: 'pointer'}} className="ti ti-trash" />
                       </button>
                  </div>
                ))}
                <button type="button" onClick={addColorInput} className="btn btn-primary mt-2">Add More</button>
              </div>

             <div className="col-md-4 mb-4">
               <label>Add Designs</label>
               {formData.design.map((d, i) => (
                <div className="form-group d-flex mt-2" key={i}>
                 <input
                   key={i}
                   className="form-control me-2"
                   value={d.design}
                   onChange={(e) => handleDesignChange(i, e.target.value)}
                 />
                <button type="button" onClick={() => handleDeletedesign(d.id)} className="btn btn-danger"> <i style={{ color: '#fff', fontSize: '1rem', transition: 'all 0.3s ease', cursor: 'pointer'}} className="ti ti-trash" />
                       </button>

                 </div>
               ))}
               <button type="button" onClick={addDesignInput} className="btn btn-primary mt-2">Add More</button>
             </div>


              <div className="col-md-4 mb-4">
                <label>Add Size</label>
                {formData.size_variation.map((entry, index) => (
                  <div className="d-flex gap-2 mb-2" key={index}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Size"
                      value={entry.size}
                      onChange={(e) => handleSizeChange(index, 'size', e.target.value)}
                    />
                    <input
                      type="text"
                      className="form-control me-2"
                      placeholder="Amount"
                      value={entry.amount}
                      onChange={(e) => handleSizeChange(index, 'amount', e.target.value)}
                    />
                    <button type="button" onClick={() => handleDeleteSize(entry.id)} className="btn btn-danger "> <i style={{ color: '#fff', fontSize: '1rem', transition: 'all 0.3s ease', cursor: 'pointer'}} className="ti ti-trash" />
                       </button>

                    
                  </div>
                ))}
                <button type="button" onClick={addSizeInput} className="btn btn-primary mt-2">Add More</button>
              </div>

              <div className="col-md-12 text-center mt-4">
                <button type="submit" className="btn btn-success w-sm-100 mb-lg-0 mb-sm-2 me-2">Update</button>
                <button type="button" className="btn btn-danger w-sm-100" onClick={() => window.location.reload()}>Reset</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    </div>
    </div>
    </>
  );
};

export default EditProduct;
